import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apartments',
  templateUrl: './apartments.component.html',
  styleUrls: ['./apartments.component.css']
})
export class ApartmentsComponent implements OnInit {

  galleryName1 = 'galleryApartment1';
  galleryName2 = 'galleryApartment2';
  galleryName3 = 'galleryApartment3';

  constructor() { }

  ngOnInit() {
    window.scroll(0, -window.scrollY);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/apartments/apartments.component.ts